import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

import { CalculatingResponsiveness } from './components/CalculatingResponsiveness';
import { useDmScoreData } from './hooks/useDmScoreData';

export function ResponsivenessScore() {
	const {
		data: { scoreTag, responsivenessScore },
	} = useDmScoreData();

	if (responsivenessScore === null || !scoreTag) return null;

	return (
		<div className="w-full lg:relative lg:mt-8 lg:w-[343px] xl:w-[496px]" data-testid="dm-responsiveness-score">
			<div
				className={cn(
					'flex w-full flex-col items-center rounded-lg bg-surface-neutral p-4 text-content-primary',
					'lg:absolute lg:right-0 lg:top-0 lg:z-20',
					'shadow-[0px_10px_20px_#18191F20]',
				)}
				// eslint-disable-next-line react/forbid-dom-props
				style={{ border: `2px solid ${scoreTag.labelColor}` }}
			>
				<Text role="heading" aria-level={2}>
					Petition response rate: {responsivenessScore}%
				</Text>
				<div
					className="my-2 rounded-full px-4 py-2 text-lg font-semibold"
					// eslint-disable-next-line react/forbid-dom-props
					style={{ backgroundColor: scoreTag.labelColor, color: scoreTag.textColor }}
				>
					{scoreTag.label}
				</div>
				<CalculatingResponsiveness />
			</div>
		</div>
	);
}
